import { useEffect, useState } from 'react'
import Turnstile from 'react-turnstile'
import styles from './AleloLayout.module.css'
import { AleloInput } from './AleloLayout'

export type CaptchaConfig = {
  provider?: string | null
  siteKey?: string | null
  image?: string | null
}

type Props = {
  config?: CaptchaConfig | null
  onToken: (token: string | undefined) => void
}

/**
 * Auth Challenge (auth0_v2 = Cloudflare Turnstile) com siteKey do Auth0.
 * Sem widget/token, LoginId.login retorna 400 no Universal Login.
 */
export function AleloCaptcha({ config, onToken }: Props) {
  const [answer, setAnswer] = useState('')

  useEffect(() => {
    onToken(undefined)
  }, [config?.provider, config?.siteKey, config?.image, onToken])

  if (!config?.provider) return null

  if (config.provider === 'auth0_v2' && config.siteKey) {
    return (
      <div className={styles.captchaSlot}>
        <Turnstile
          sitekey={config.siteKey}
          theme="light"
          size="normal"
          onVerify={(token) => onToken(token)}
          onExpire={() => onToken(undefined)}
          onError={() => onToken(undefined)}
        />
      </div>
    )
  }

  // Captcha de imagem do Auth0: campo Rango (64px, label visível), sem o
  // scale do slot do Turnstile, que só existe por causa da largura fixa dele.
  if (config.provider === 'auth0' && config.image) {
    return (
      <div className={styles.captchaImage}>
        <img
          src={config.image}
          alt="Imagem com o código de verificação"
          width={180}
          height={60}
        />
        <AleloInput
          label="Código da imagem"
          type="text"
          value={answer}
          onChange={(e) => {
            const v = e.target.value
            setAnswer(v)
            onToken(v.trim() || undefined)
          }}
          autoComplete="off"
          autoCapitalize="none"
          spellCheck={false}
        />
      </div>
    )
  }

  return null
}
